import { render, staticRenderFns } from "./data-table.vue?vue&type=template&id=5f04a9ec&scoped=true&"
import script from "./data-table.vue?vue&type=script&lang=js&"
export * from "./data-table.vue?vue&type=script&lang=js&"
import style0 from "./data-table.vue?vue&type=style&index=0&id=5f04a9ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f04a9ec",
  null
  
)

export default component.exports